import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-small text-muted mb-4" }, "Ajustes de usuario", -1)
const _hoisted_2 = { class: "pl-lg-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Abrir el panel automáticamente (omnicanal) ")
const _hoisted_6 = {
  key: 0,
  class: "row my-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-tittle text-muted" }, " Dispositivos de salida para llamadas ", -1)
const _hoisted_8 = { class: "w-100 d-flex justify-content-center align-items-center" }
const _hoisted_9 = { class: "col-10" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger my-1"
}
const _hoisted_11 = { class: "col-2 w-100" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bullhorn el-icon" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save el-icon" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-tittle text-muted" }, " Dispositivos de salida para tono de llamada o notificaciones omnicanal ", -1)
const _hoisted_15 = { class: "w-100 d-flex align-items-center" }
const _hoisted_16 = { class: "col-10" }
const _hoisted_17 = { class: "mt-1" }
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 col-md-2 col-lg-1 m-0 p-0 align-self-center" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "heading-tittle text-muted p-0 m-0" }, "volumén")
], -1)
const _hoisted_20 = { class: "col-sm-9 col-md-10 col-lg-11 m-0 p-0" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger my-1"
}
const _hoisted_22 = { class: "col-2 w-100" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bullhorn el-icon" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save el-icon" }, null, -1)
const _hoisted_25 = {
  key: 2,
  class: "row my-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-tittle text-muted" }, " Dispositivos de entrada para llamadas ", -1)
const _hoisted_27 = { class: "w-100 d-flex justify-content-center align-items-center" }
const _hoisted_28 = { class: "col-10" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger my-1"
}
const _hoisted_30 = { class: "col-2 w-100" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-microphone el-icon" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save el-icon" }, null, -1)

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { AppModule, IUserSettings } from "@/store/modules/app";
import { AlertModule } from "@/store/modules/Alert";
import { env } from "@/config";
import { AuthModule } from "@/store/modules/Auth";
import { AuthStatus } from "@/types/router";
import { OutputDeviceModule } from "@/store/modules/OutputDevice";
import WaveSurfer from "wavesurfer.js";
import RecordPlugin from "wavesurfer.js/dist/plugins/record.esm.js";
import RecordPluginType from "wavesurfer.js/dist/plugins/record";

interface IDevice {
	deviceId: string;
	groupId: string;
	kind: string;
	label: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loginWithCallCenter = computed(
	() =>
		env.requiredCallcenter &&
		AuthModule.status === AuthStatus.FULL_AUTHENTICATED
);
const callTestFailed = computed(() => OutputDeviceModule.CallTestFailed);
const ringTestFailed = computed(() => OutputDeviceModule.RingTestFailed);

const userSettings = ref<IUserSettings>({
	showSidebar: AppModule.userSettings.showSidebar,
});
const outputDevices = ref<null | IDevice[]>(null);
const inputDevices = ref<null | IDevice[]>(null);
const selectedOutputDevice = ref();
const selectedInputDevice = ref();
const selectedRigtoneDevice = ref();
const reproducingTest = ref(false);
const reproducingRigtoneTest = ref(false);
const recordingTest = ref(false);
const ringVolume = ref(0);

const audio: HTMLMediaElement & { setSinkId: (param: any) => Promise<void> } =
	new Audio("/audio/output_device_test.mp3") as any;
const ringtoneAudio: HTMLMediaElement & {
	setSinkId: (param: any) => Promise<void>;
} = new Audio("/media/Ringtone_2.mp3") as any;
let audioRecorder: MediaRecorder;
let audioPlayer: HTMLMediaElement & {
	setSinkId: (param: any) => Promise<void>;
};
let waveSurfer: WaveSurfer;
let recorder: RecordPluginType;

function setUserSettings() {
	AppModule.setUserSettings(userSettings.value);
}

watch(
	() => AppModule.userSettings,
	() => {
		userSettings.value.showSidebar = AppModule.userSettings.showSidebar;
	}
);

const testOutputDevice = () => {
	if (reproducingRigtoneTest.value) {
		ringtoneAudio.pause();
		reproducingRigtoneTest.value = false;
	}
	if (reproducingTest.value) {
		audio.pause();
		reproducingTest.value = false;
	} else {
		if (selectedOutputDevice.value) {
			audio
				.setSinkId(selectedOutputDevice.value)
				.then(() => {
					audio.loop = true;
					audio.play();
					reproducingTest.value = true;
				})
				.catch(() => {
					AlertModule.SOCKET_PUSH_NOTIFICATION({
						text: "No se ha podido reproduciar la prueba en el dispositivo seleccionado",
						type: "error",
					});
				});
		} else
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: "No se ha seleccionado un dispositivo de salida de audio para llamada",
				type: "error",
			});
	}
};

const testRigtoneOutputDevice = () => {
	if (reproducingTest.value) {
		audio.pause();
		reproducingTest.value = false;
	}
	if (reproducingRigtoneTest.value) {
		ringtoneAudio.pause();
		reproducingRigtoneTest.value = false;
	} else {
		if (selectedRigtoneDevice.value) {
			ringtoneAudio
				.setSinkId(selectedRigtoneDevice.value)
				.then(() => {
					ringtoneAudio.loop = true;
					ringtoneAudio.volume = ringVolume.value / 100;
					ringtoneAudio.play();
					reproducingRigtoneTest.value = true;
				})
				.catch(() => {
					AlertModule.SOCKET_PUSH_NOTIFICATION({
						text: "No se ha podido reproduciar la prueba en el dispositivo seleccionado",
						type: "error",
					});
				});
		} else
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: "No se ha seleccionado un dispositivo de salida de audio para tono de llamada",
				type: "error",
			});
	}
};

const testInputDevice = () => {
	if (selectedInputDevice.value) {
		if (recordingTest.value) {
			audioRecorder.pause();
			audioRecorder.stop();
			recorder.stopRecording();
			audioPlayer.pause();
			recorder.destroy();
			waveSurfer.destroy();
		} else {
			navigator.mediaDevices
				.getUserMedia({
					audio: {
						deviceId: { exact: selectedInputDevice.value ?? "default" },
					},
				})
				.then(async stream => {
					audioRecorder = new MediaRecorder(stream);
					audioRecorder.start();
					audioPlayer = new Audio() as any;
					await audioPlayer.setSinkId(selectedRigtoneDevice.value ?? "default");
					audioPlayer.autoplay = true;
					audioPlayer.srcObject = stream;
					waveSurfer = WaveSurfer.create({
						container: "#wave-container",
						waveColor: "#652efd",
						progressColor: "#fff",
					});
					recorder = waveSurfer.registerPlugin(
						RecordPlugin.create({
							scrollingWaveform: false,
							renderRecordedAudio: false,
						})
					);
					recorder.startRecording({
						deviceId: selectedInputDevice.value ?? "default",
					});
				});
		}
		recordingTest.value = !recordingTest.value;
	} else
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "No se ha seleccionado un dispositivo de entrada de audio",
			type: "error",
		});
};

const saveAudioSetting = () => {
	if (selectedOutputDevice.value) {
		const deviceName =
			outputDevices.value?.find(
				od => od.deviceId === selectedOutputDevice.value
			)?.label ?? "";
		OutputDeviceModule.setCallOutputDevice({
			deviceId: selectedOutputDevice.value,
			deviceName,
			alert: true,
		});
	} else
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "No se ha seleccionado un dispositivo de salida de audio para llamada",
			type: "error",
		});
};

const saveRingtoneAudioSetting = () => {
	if (selectedRigtoneDevice.value) {
		const deviceName =
			outputDevices.value?.find(
				od => od.deviceId === selectedRigtoneDevice.value
			)?.label ?? "";
		OutputDeviceModule.setRingtoneOutputDevice({
			deviceId: selectedRigtoneDevice.value,
			deviceName,
			deviceVolume: ringVolume.value.toString(),
			alert: true,
		});
	} else
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "No se ha seleccionado un dispositivo de salida de audio para tono de llamada",
			type: "error",
		});
};

const saveInputAudioSetting = () => {
	if (selectedInputDevice.value) {
		const deviceName =
			inputDevices.value?.find(id => id.deviceId === selectedInputDevice.value)
				?.label ?? "";
		OutputDeviceModule.setInputAudioDevice({
			deviceId: selectedInputDevice.value,
			deviceName,
			alert: true,
		});
	} else
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "No se ha seleccionado un dispositivo de entrada de audio",
			type: "error",
		});
};

onMounted(() => {
	navigator.mediaDevices
		.getUserMedia({ audio: true })
		.then(() => {
			navigator.mediaDevices.enumerateDevices().then(devices => {
				outputDevices.value = devices.filter(device => {
					return device.kind === "audiooutput";
				});

				inputDevices.value = devices.filter(device => {
					return device.kind === "audioinput";
				});
			});
		})
		.catch(err => {
			outputDevices.value = null;
			inputDevices.value = null;
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text:
					err.message === "Requested device not found"
						? "No se ha encontrado un dispositivo de entrada de audio (micrófono) conectado"
						: "No se han dado los permisos para administrar los dispositivos de salida",
				type: "error",
			});
		});

	const callDeviceId = OutputDeviceModule.CallOutputDevice;
	if (callDeviceId) selectedOutputDevice.value = callDeviceId;

	const ringtoneDeviceId = OutputDeviceModule.RingtoneOutputDevice;
	if (ringtoneDeviceId) selectedRigtoneDevice.value = ringtoneDeviceId;

	const ringtoneVolume = OutputDeviceModule.ringtoneOutputDeviceVolume;
	if (ringtoneVolume) ringVolume.value = ringtoneVolume;

	const inputDeviceId = OutputDeviceModule.CallInputDevice;
	if (inputDeviceId) selectedInputDevice.value = inputDeviceId;
});

onUnmounted(() => {
	if (reproducingTest.value) {
		audio.pause();
		reproducingTest.value = false;
	}

	if (reproducingRigtoneTest.value) {
		ringtoneAudio.pause();
		reproducingRigtoneTest.value = false;
	}

	if (recordingTest.value) {
		audioRecorder.pause();
		audioRecorder.stop();
		recorder.stopRecording();
		recorder.destroy();
		audioPlayer.pause();
		waveSurfer.destroy();
	}
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_checkbox, {
            onChange: setUserSettings,
            modelValue: userSettings.value.showSidebar,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userSettings.value.showSidebar) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      (outputDevices.value != null && _unref(loginWithCallCenter))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_select, {
                  modelValue: selectedOutputDevice.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOutputDevice).value = $event)),
                  style: {"width":"100%"},
                  size: "small",
                  placeholder: "Seleccione el dispositivo de salida de audio para llamada"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outputDevices.value, (device) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: device.deviceId,
                        label: device.label,
                        value: device.deviceId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_unref(callTestFailed))
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_10, " Verificar este dispositivo de salida "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_tooltip, {
                  content: reproducingTest.value ? 'Detener' : 'Probar dispositivo',
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: reproducingTest.value ? 'warning' : 'info',
                      circle: "",
                      onClick: testOutputDevice
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ]),
                  _: 1
                }, 8, ["content"]),
                _createVNode(_component_el_tooltip, {
                  content: "Guardar",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      circle: "",
                      onClick: saveAudioSetting
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (outputDevices.value != null)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["row", { 'mt-3': !_unref(loginWithCallCenter) }])
          }, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_select, {
                  modelValue: selectedRigtoneDevice.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedRigtoneDevice).value = $event)),
                  style: {"width":"100%"},
                  size: "small",
                  placeholder: "Seleccione el dispositivo de salida de audio para tono de llamada o notificaciones omnicanal"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outputDevices.value, (device) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: device.deviceId,
                        label: device.label,
                        value: device.deviceId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_slider, {
                        modelValue: ringVolume.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ringVolume).value = $event)),
                        step: 5
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                (_unref(ringTestFailed))
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_21, " Verificar este dispositivo de salida "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_tooltip, {
                  content: 
								reproducingRigtoneTest.value ? 'Detener' : 'Probar dispositivo'
							,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: reproducingRigtoneTest.value ? 'warning' : 'info',
                      circle: "",
                      onClick: testRigtoneOutputDevice
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ]),
                  _: 1
                }, 8, ["content"]),
                _createVNode(_component_el_tooltip, {
                  content: "Guardar",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      circle: "",
                      onClick: saveRingtoneAudioSetting
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (inputDevices.value != null && _unref(loginWithCallCenter))
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_el_select, {
                  modelValue: selectedInputDevice.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedInputDevice).value = $event)),
                  style: {"width":"100%"},
                  size: "small",
                  placeholder: "Seleccione el dispositivo de salida de audio para llamada"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputDevices.value, (device) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: device.deviceId,
                        label: device.label,
                        value: device.deviceId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_unref(callTestFailed))
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_29, " Verificar este dispositivo de salida "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  id: "wave-container",
                  class: _normalizeClass(["mt-2", { 'show-wave': recordingTest.value }])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_tooltip, {
                  content: recordingTest.value ? 'Finalizar prueba' : 'Probar micrófono',
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: recordingTest.value ? 'warning' : 'info',
                      circle: "",
                      onClick: testInputDevice
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }, 8, ["type"])
                  ]),
                  _: 1
                }, 8, ["content"]),
                _createVNode(_component_el_tooltip, {
                  content: "Guardar",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      circle: "",
                      onClick: saveInputAudioSetting
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})